/**
 * PostaEditoru — Posta listeleri'nde yazılan postanın gövde editörü (backlog #585). Şablon sayfasının tam donanımlı editörünün sade hali: yazı biçimi,
 * bağlantı, liste, hizalama, alıntı, çizgi ve "Kaynak" (HTML). Çıktı doğrudan postanın gövdesidir; adres hitabı ya da ad yer tutucusu yoktur.
 */
import React from "react";
import "ckeditor5/ckeditor5.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
    Alignment, AutoLink, BlockQuote, Bold, ClassicEditor, Essentials, FontColor, FontSize, GeneralHtmlSupport, Heading, HorizontalLine,
    Image, ImageInsert, ImageResize, ImageStyle, ImageTextAlternative, ImageToolbar, ImageUpload,
    Indent, IndentBlock, Italic, Link, List, Paragraph, RemoveFormat, SourceEditing, Strikethrough, Underline,
} from "ckeditor5";
import { EpostaResimYuklemeEklentisi } from "../../../../../services/epostaResimYukle";

const config = {
    toolbar: {
        items: [
            "undo", "redo", "|", "heading", "|", "bold", "italic", "underline", "strikethrough", "removeFormat", "|",
            "fontSize", "fontColor", "|", "link", "insertImage", "bulletedList", "numberedList", "outdent", "indent", "|",
            "alignment", "blockQuote", "horizontalLine", "|", "sourceEditing",
        ],
        shouldNotGroupWhenFull: true,
    },
    plugins: [
        Alignment, AutoLink, BlockQuote, Bold, Essentials, FontColor, FontSize, GeneralHtmlSupport, Heading, HorizontalLine,
        Indent, IndentBlock, Italic, Link, List, Paragraph, RemoveFormat, SourceEditing, Strikethrough, Underline,
        Image, ImageInsert, ImageResize, ImageStyle, ImageTextAlternative, ImageToolbar, ImageUpload,   // 2026-10-30 (Bilge): images in a list mail
    ],
    extraPlugins: [EpostaResimYuklemeEklentisi],
    image: { upload: { types: ["jpeg", "png", "gif", "webp"] }, toolbar: ["imageTextAlternative", "|", "imageStyle:inline", "|", "resizeImage"] },
    fontSize: { options: ["default", 12, 14, 16, 18, 20, 24], supportAllValues: true },
    htmlSupport: { allow: [{ name: /^.*$/, styles: true, attributes: true, classes: true }] },
    link: { addTargetToExternalLinks: true, defaultProtocol: "https://" },
    language: "tr",
};

const PostaEditoru = ({ value, onChange }) => (
    <CKEditor
        editor={ClassicEditor}
        data={value || ""}
        config={config}
        onChange={(event, editor) => onChange(editor.getData())}
    />
);

export default PostaEditoru;
